import { ref, onMounted, watch } from 'vue'
import request from '@/api/request'
import { useI18n } from 'vue-i18n'

export function useConfig() {
  const configs = ref({})
  const loading = ref(false)
  const { locale } = useI18n() // 获取当前语言

  const loadConfigs = async () => {
    loading.value = true
    try {
      const response = await request.get('/configs/all')
      if (response.code === 200) {
        const configObj = {}
        response.data.forEach(item => {
          // 检查配置值是否为JSON字符串
          try {
            const parsedValue = JSON.parse(item.configValue);
            // 如果是有效的JSON对象，则保留原始JSON
            configObj[item.configKey] = parsedValue;
          } catch (e) {
            // 如果不是JSON，则保留原始字符串值
            configObj[item.configKey] = item.configValue;
          }
        })
        configs.value = configObj
      }
    } catch (error) {
      console.error('加载配置失败:', error)
    } finally {
      loading.value = false
    }
  }

  const getConfig = (key, defaultValue = '') => {
    const rawValue = configs.value[key];
    
    // 检查rawValue是否为多语言对象
    if (rawValue && typeof rawValue === 'object') {
      // 尝试获取当前语言的确切匹配 (如 'en-US')
      if (rawValue[locale.value]) {
        return rawValue[locale.value]
      }
      
      // 尝试获取当前语言的主要语言代码 (如 'en' 而不是 'en-US')
      const mainLang = locale.value.split('-')[0]
      if (rawValue[mainLang]) {
        return rawValue[mainLang]
      }
      
      // 尝试获取英文版本 (常见替代)
      if (rawValue['en']) {
        return rawValue['en']
      }
      
      // 尝试获取中文版本 (默认)
      if (rawValue['zh'] || rawValue['zh-CN']) {
        return rawValue['zh'] || rawValue['zh-CN']
      }
      
      // 如果以上都没有，返回默认值
      return defaultValue
    }
    
    // 如果不是多语言对象，直接返回原始值
    return rawValue || defaultValue
  }

  onMounted(() => {
    loadConfigs()
  })

  // 监听语言变化，重新加载配置以更新内容
  watch(locale, async () => {
    await loadConfigs()
  })

  return {
    configs,
    loading,
    loadConfigs,
    getConfig
  }
}